<template>
	<nav class="nav nav-pills flex-row" id="nav">
    <router-link class="flex-fill text-center nav-link" exact active-class="active" :to="`/signing_digital_contract/${defaultlayoutUuid}/${defaultlayoutSgid}/${defaultlayoutChecksum}`">合約主文</router-link>
    <router-link class="flex-fill text-center nav-link " exact active-class="active" :to="`/archives/${defaultlayoutUuid}/${defaultlayoutSgid}/${defaultlayoutChecksum}`">合約附件圖片</router-link>
    <router-link class="flex-fill text-center nav-link nav-sign " exact active-class="active" :to="`/sign/${defaultlayoutUuid}/${defaultlayoutSgid}/${defaultlayoutChecksum}`">簽名</router-link>
  </nav>
</template>

<script>
export default {
  name: 'footerBottom',
  props: ["defaultlayoutUuid", "defaultlayoutSgid","defaultlayoutChecksum"],
  mounted () {
    console.log('infooter');
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#nav{
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 0 5px #d2d2d295;

  
}
#nav .nav-link{
  padding: 15px;
  /* border-top: 1px solid #ddd; */
  /* border-left: 1px solid #ddd; */
  border-radius: unset !important;
  color: #333;
  font-weight: 600;
}
#nav .nav-link.active{
  color: #fff;
}
.nav-sign{
  background-color: rgb(255 205 98 / 89%);
}
#nav .nav-link:first-of-type{
  border-right: none;

}

#nav .nav-link:hover{
    background-color: var(--bs-nav-pills-link-active-bg);
    color: #fff;
}
</style>
